module.exports = __webpack_public_path__ + "static/media/github.2ab78be8.svg";